import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { CoreLoadingScreenService } from '@core/services/loading-screen.service';

@Component({
  selector: 'app-mobile-card-payment',
  templateUrl: './mobile-card-payment.component.html',
  styleUrls: ['./mobile-card-payment.component.scss']
})
export class MobileCardPaymentComponent implements OnInit {
  // Netopia v1
  paymentEnvKey: string;
  paymentData: string;
  paymentUrl: string;

  // Netopia v2 — frictionless
  v2PaymentUrl: string;

  // Netopia v2 — 3DS challenge
  v2AcsUrl: string;
  v2FormData: { [key: string]: string };

  isError = false;
  selectedLanguage = 'ro';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loadingService: CoreLoadingScreenService
  ) {}

  ngOnInit(): void {
    this.readHashFragment();

    const isV1 = !!this.paymentEnvKey && !!this.paymentData && !!this.paymentUrl;
    const isV2Frictionless = !!this.v2PaymentUrl;
    const isV2ThreeDS = !!this.v2AcsUrl;

    if (!isV1 && !isV2Frictionless && !isV2ThreeDS) {
      this.router.navigate(['/pages/miscellaneous/not-found']);
    } else {
      this.loadingService.show();
      if (isV2ThreeDS) {
        this.submitAcsForm();
      } else if (isV2Frictionless) {
        window.location.href = this.v2PaymentUrl;
      } else {
        this.submitPaymentForm();
      }
    }
  }

  private readHashFragment(): void {
    const hash = window.location.hash.substring(1); // Remove the # symbol
    if (!hash) { return; }

    const params: { [key: string]: string } = {};
    hash.split('&').forEach(param => {
      const [key, value] = param.split('=');
      if (key && value) {
        params[key] = decodeURIComponent(value);
      }
    });

    // Netopia v1
    this.paymentEnvKey = params['paymentEnvKey'] || '';
    this.paymentData   = params['paymentData']   || '';
    this.paymentUrl    = params['paymentUrl']    || '';

    // Netopia v2 — frictionless
    this.v2PaymentUrl = params['v2PaymentUrl'] || '';

    // Netopia v2 — 3DS challenge
    this.v2AcsUrl    = params['v2AcsUrl']    || '';
    if (params['v2FormData']) {
      try {
        this.v2FormData = JSON.parse(params['v2FormData']);
      } catch {
        this.v2FormData = {};
      }
    }
  }

  /** Netopia v2 — 3DS: hidden form POST to the bank ACS URL */
  private submitAcsForm(): void {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = this.v2AcsUrl;

    for (const [key, value] of Object.entries(this.v2FormData ?? {})) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
  }

  /** Netopia v1: hidden form POST to the gateway */
  private submitPaymentForm() {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = this.paymentUrl;

    const envKeyInput = document.createElement('input');
    envKeyInput.value = this.paymentEnvKey;
    envKeyInput.name = 'env_key';
    envKeyInput.type = 'hidden';
    form.appendChild(envKeyInput);

    const dataInput = document.createElement('input');
    dataInput.value = this.paymentData;
    dataInput.name = 'data';
    dataInput.type = 'hidden';
    form.appendChild(dataInput);

    document.body.appendChild(form);
    form.submit();

    setTimeout(() => {
      this.loadingService.hide();
    }, 1000);
  }
}
